export const FORMATTED_VALUE_FALLBACK = '-';

const normalizeFiniteNumber = (value: unknown): number | null => {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return null;
  }

  return value;
};

const formatWithDigits = (
  value: unknown,
  locale: string,
  {
    minimumFractionDigits,
    maximumFractionDigits,
    fallback = FORMATTED_VALUE_FALLBACK,
  }: {
    minimumFractionDigits: number;
    maximumFractionDigits: number;
    fallback?: string;
  },
): string => {
  const numeric = normalizeFiniteNumber(value);
  if (numeric === null) {
    return fallback;
  }

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(numeric);
};

export const formatCount = (
  value: unknown,
  locale: string,
  fallback = FORMATTED_VALUE_FALLBACK,
): string => {
  const numeric = normalizeFiniteNumber(value);
  if (numeric === null) {
    return fallback;
  }

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(numeric);
};

export const formatTemperature = (
  value: unknown,
  locale: string,
  fallback = FORMATTED_VALUE_FALLBACK,
): string => {
  return formatWithDigits(value, locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
    fallback,
  });
};

export const formatPower = (
  value: unknown,
  locale: string,
  fallback = FORMATTED_VALUE_FALLBACK,
): string => {
  return formatWithDigits(value, locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
    fallback,
  });
};
